import { useEffect } from 'react';
import {
  SidebarMenuItemType,
  ChatFeedbackModal,
  useFeedback,
  MessagesContainerStack,
  CHATAI_LOADING_STATUS,
  ChatAIInput,
  useChatContext,
} from '@ltvco/refresh-lib/v2';
import { useScreenSize } from '@ltvco/refresh-lib/utils';
import { MessagesContainer } from './MessagesContainer';
import { CameraAltOutlined } from '@mui/icons-material';
import { Divider, Stack, Text } from '@ltvco/refresh-lib/theme';
import { theme } from 'theme';

export const additionalSidebarItems: SidebarMenuItemType[] = [
  {
    key: 'photoDamageAnalyzer',
    icon: CameraAltOutlined,
    label: 'Photo Damage Analyzer',
    url: '/bumper-chat/chat/photo-damage-analyzer',
    tooltip: 'Photo Damage Analyzer',
  },
];

export const DamageAnalyzerPage = () => {
  const { isMobile } = useScreenSize();
  const { messages, loadingStatus, sendMessage, handleFeatureNameChange } =
    useChatContext();
  const {
    openFeedback,
    thumbsUp,
    currentResponseId,
    feedback,
    createFeedback,
    updateFeedback,
    handleCloseFeedback,
  } = useFeedback(messages);

  useEffect(() => {
    handleFeatureNameChange('createVehiclePhotoDamageAnalyzerBot');
  }, [handleFeatureNameChange]);

  return (
    <Stack direction="column" width="100%" height="100%">
      <MessagesContainerStack
        spacing={2}
        sx={{
          width: '100%',
          height: '100%',
          position: 'relative',
        }}
      >
        <Stack width="100%" maxWidth="760px" spacing={2}>
          <Stack direction="row" alignItems="center" gap={1}>
            <CameraAltOutlined sx={{ color: theme.palette.primary.main }} />
            <Text variant="h5" mb={0}>
              Photo Damage Analyzer
            </Text>
          </Stack>
          <Divider sx={{ width: '100%' }} />
        </Stack>
        <MessagesContainer
          messages={messages}
          loadingStatus={loadingStatus}
          onSendMessage={sendMessage}
        />
        {!isMobile && (
          <ChatAIInput
            isLoading={
              loadingStatus.message !== CHATAI_LOADING_STATUS.IDLE.message
            }
            disabled={messages.length === 0}
          />
        )}
      </MessagesContainerStack>
      <ChatFeedbackModal
        open={openFeedback}
        onClose={handleCloseFeedback}
        thumbsUp={thumbsUp}
        responseItemId={currentResponseId}
        createFeedback={createFeedback}
        updateFeedback={updateFeedback}
        hasRecord={typeof feedback[currentResponseId]?.thumbs_up === 'boolean'}
        feedbackText={
          feedback[currentResponseId]?.feedback?.feedback_text || ''
        }
      />
    </Stack>
  );
};
